const re = /^\d{3}\-\d{3}\-\d{3}\-\d{2}$/i;

export function isSnilsValid(str) {
    return re.test(str);
}
